import { Component, Input } from '@angular/core';

@Component({
    selector: "app-color-legends",
    template: `<div class="legends-container">@for(legend of colorlegends; track legend){
    <div class="legend-item">
      <span
        class="legend-dot"
        [style.background-color]="legend.color"
      ></span>
      {{ legend.label }}
    </div>
    }</div>`,
    styleUrl: "./color-legends.component.scss",
    standalone: false
})
export class ColorLegendsComponent {
  @Input() colorlegends: any[];
  constructor() {}

  
}
